import { Range } from '@shared/UI';
import { withField } from '../withField';

export const RangeField = withField(Range);
